import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=09ff7f10&scoped=true&"
import script from "./Alert.vue?vue&type=script&lang=js&"
export * from "./Alert.vue?vue&type=script&lang=js&"
import style0 from "./Alert.vue?vue&type=style&index=0&id=09ff7f10&lange=scsss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ff7f10",
  null
  
)

export default component.exports